import { Link } from "react-router-dom";
import { useContext, useState, useRef, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import "../css/Navbar.css";



type Fase =
  | "grupos"
  | "dieciseisavos"
  | "octavos"
  | "cuartos"
  | "semifinal"
  | "final";

interface NavbarProps {
  estadoTorneo: Fase;
}

const Navbar = ({ estadoTorneo }: NavbarProps) => {

  const [menuOpen, setMenuOpen] = useState(false);

  const orden: Fase[] = [
    "grupos",
    "dieciseisavos",
    "octavos",
    "cuartos",
    "semifinal",
    "final",
  ];

const faseDisponible = (fase: Fase) => {
  return (
    orden.indexOf(estadoTorneo) >= orden.indexOf(fase)
  );
};

  const userContext = useContext(UserContext);
  if (!userContext) return null;

  const { user, logout } = userContext;
  const isLogged = !!user;

  const [faseOpen, setFaseOpen] = useState(false);
  const [mostrarCodigo, setMostrarCodigo] = useState(false);
const dropdownRef = useRef<HTMLDivElement | null>(null);

useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setFaseOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  return (
    <nav className="navbar">
      <div className="nav-left">
        <img src="/copa.png" alt="Copa" className="nav-logo" />
        <h2>Predicciones 2026</h2>
      </div>
      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </button>

      <div className={`nav-menu ${menuOpen ? "open" : ""}`}>

        {/* ID con botón ojito */}
        {user && (
          <div className="user-code-container">
            <span className="user-label">ID:</span>

            <span className={`user-number ${!mostrarCodigo ? "blurred" : ""}`}>
              {user.codigo_usuario}
            </span>

            <button
              className="eye-btn"
              onClick={() => setMostrarCodigo(!mostrarCodigo)}
              type="button"
            >
              {mostrarCodigo ? "🙈" : "👁️"}
            </button>
          </div>
        )}

        {/* Dropdown FASE */}
        <div className="dropdown" ref={dropdownRef}>
            <button
              className="dropdown-title"
              onClick={() => setFaseOpen(!faseOpen)}
              type="button"
            >
              Fase ▾
            </button>

          {faseOpen && (
            <div className="dropdown-menu">

              {[
                { id: "grupos", label: "Fase de Grupos" },
                { id: "dieciseisavos", label: "Dieciseisavos" },
                { id: "octavos", label: "Octavos" },
                { id: "cuartos", label: "Cuartos" },
                { id: "semifinal", label: "Semifinal" },
                { id: "final", label: "Final" },
              ].map((fase) => {
                const habilitada = faseDisponible(fase.id as Fase);

                return habilitada ? (
                  <a
                    key={fase.id}
                    href={`#${fase.id}`}
                    onClick={() => setFaseOpen(false)}
                  >
                    {fase.label}
                  </a>
                ) : (
                  <span key={fase.id} className="fase-disabled">
                    {fase.label}
                  </span>
                );
              })}

            </div>
          )}

        </div>

        <a href="#campeon">Predicción Campeón</a>



        {!isLogged && (
          <>
            <Link to="/register">Registrarme</Link>
            <Link to="/login">Iniciar sesión</Link>
          </>
        )}

        {isLogged && (
          <>
            <a href="#comprar-puntos">Comprar puntos</a>
            <button className="btn-logout" onClick={logout}>
              Cerrar sesión
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
